/**
 * @license Copyright (c) 2017-2019, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md.
 */

export function setupHighlight() {
	const blocks = Array.from( document.querySelectorAll( 'pre code' ) );
	const worker = new Worker( window.umberto.relativeAppPath + '/highlight.worker.js' );

	worker.addEventListener( 'message', evt => {
		const data = JSON.parse( evt.data );
		const block = blocks[ data.index ];
		block.innerHTML = data.payload;
		block.classList.add( 'hljs' );
	} );

	blocks.forEach( ( block, index ) => {
		worker.postMessage( JSON.stringify( {
			index,
			payload: block.textContent,
			language: block.className
		} ) );
	} );
}
